import type { Components, Theme } from '@mui/material/styles';

const MuiToolbar: Components['MuiToolbar'] = {
  styleOverrides: {
    root: ({ theme: { spacing } }: { theme: Theme }) => ({
      '&.MuiToolbar-regular': { padding: spacing(1.25, 5) }
    })
  }
} as never;

export default MuiToolbar;
